<template>
  <div class="query-result-container">
    <a-layout>
      <a-layout-header>
        <header-action></header-action>
      </a-layout-header>
      <a-layout>
        <a-layout-sider>
          <sider-form></sider-form>
        </a-layout-sider>
        <a-layout-content>
          <content-list :is-admin="isAdmin"></content-list>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import HeaderAction from '@/views/query-result/components/HeaderAction'
import ContentList from '@/views/query-result/components/ContentList'
import SiderForm from '@/views/query-result/components/SiderForm'

// 校验对象是不是空对象
function isEmpty(obj) {
      if(Object.keys(obj).length === 0) {
        return true
      }
      return false
}

export default {
  components:{
    HeaderAction,
    ContentList,
    SiderForm
  },
  data() {
    return {
      isAdmin:false,
      adminCodes:'qVBXdjFQ30Z9nJE91C2TxKMbh8yZQPMdNapCBISTK5C6sUs5PFI7DSSrSySQQLep'
    }
  },
  created() {
    // 判断是否有人非法尝试进入
    // if(isEmpty(this.$route.query)) return this.$router.replace('/home')

    // 校验 query 参数
    let {admin_daqiang} = this.$route.query

    // console.log(admin_daqiang === this.adminCodes);

    if(admin_daqiang && admin_daqiang === this.adminCodes){
      this.isAdmin = true
    }
  },
  mounted(){
    //
  }
};
</script>

<style lang="less" scoped>
.query-result-container {
  .ant-layout-header {
    // height: 120px;
    background: #001529;
    color: #000;
    
  }

  .ant-layout {
    height: 100vh;
    .ant-layout-sider {
      padding: 12px;
      width: 300px !important;
      max-width: 300px !important;
      min-width: 300px !important;
      background-color: #fff;
      color:#000;
    }
    .ant-layout-content {
      padding: 24px;
      background-color: #f0f2f5;
    }
  }
}
</style>